// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Kb603qHw-hEDR0RunUDBe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/SharespacePublishButton/SharespacePublishButton.scss
// module id = 1373
// module chunks = 1